// extracted by mini-css-extract-plugin
export default {"verticalThirdLowerContainer":"pageContainer_verticalThirdLowerContainer__5yuKi"};